import React, { useState, useEffect } from "react";
import "./style.scss";
import { getCookie } from '../../../dv2_temporary_solution/util/cookies';

const CookieConsent = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const consent = getCookie('cookieConsent');
    if (!consent) {
      setShowPopup(true); // Show popup if consent isn't stored
    }
  }, []);

  const setCookie = (name, value) => {
    document.cookie = `${name}=${value}; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT`;
  };

  const handleAccept = () => {
    setCookie('cookieConsent', true);
    setShowPopup(false);
  };

  const handleReject = () => {
    setCookie('cookieConsent', false);
    setShowPopup(false);
  };
  
  const handleDismiss = () => {
    setShowPopup(false);
  }
  
  if (!showPopup) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-box">
        <button className="cookie-consent-close" onClick={handleDismiss}>
          ✕
        </button>
        <p>
          We use cookies to improve your experience on our site. By accepting, you agree to our use of cookies. For more
          information, read our <a href="https://turing.com/terms-of-service" target="_blank" rel="noopener noreferrer">Terms
          of Service</a> and <a href="https://turing.com/policy" target="_blank" rel="noopener noreferrer">Privacy
          Policy</a>.
        </p>
        <div className="cookie-consent-buttons">
          <button onClick={handleAccept} className="cookie-consent-accept">
            I understand
          </button>
          <button onClick={handleReject} className="cookie-consent-reject">
            Opt out
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
